import React, { useEffect, useState } from 'react';
import Layout from '../../../Layout';
// import EmptyComponentLink from '../../../components/EmptyComponent/EmptyComponentLink';
import { CopyOutlined, EditOutlined, EyeOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Switch, Tooltip } from 'antd';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as RankApi from '../../../api/rank/rankApi';
import { gold_image, none_rank } from '../../../components/ExportImgFigma';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import { URL_RANK } from '../../../env';
import useToast from '../../../hook/useToast';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { checkDisabledPermission, getUserPermissions } from '../../../until';
import './ClassList.scss';
import ModalScoringRules from './ComponentAddRank/ModalScoringRules';
import ShowRank from './ShowRank';
import ModalWarning from '../../../components/ModalWarning';

const ClassList: React.FC = () => {
  useEffect(() => {
    document.title = 'THACO AUTO CRM';
  }, []);

  const pushToast = useToast();
  const navigate = useNavigate()
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isDelete, upload, download, share, } = getUserPermissions(permissionSlice, location.pathname)

  const [isShowRank, setShowRank] = useState(false)
  const [isModalScoringRules, setIsModalScoringRules] = useState(false)
  const [isShowWarning, setShowWarning] = useState(false)



  const [openDeleteListRank, setOpenDeleteListRank] = useState(false)
  const [dataRank, setDataRank] = useState<RankApi.IRank[]>([])
  const [dataBenefitRank, setDataBenefitRank] = useState<RankApi.IInfoRank>()
  const [total, setTotal] = useState<number>()
  const [messageWarning, setMessageWarning] = useState<string>('')

  const [id, setId] = useState<number>()


  const getListRank = async () => {
    const result = await RankApi.getListRank();
    if (result?.status) {
      setDataRank(result.data)
      setTotal(result?.total)
    } else {
      pushToast(result?.message, "error", 2000)

    }
  }

  // const getListBenefitRank = async (id: number) => {
  //   const result = await BenefitApi.getListBenefitRank(id);
  //   if (result?.status) {
  //     setDataBenefitRank(result.data);
  //   } else {
  //     pushToast(result?.message, "error", 2000)

  //   }
  // }


  const getInfoRank = async (id: number) => {
    const result = await RankApi.getInfoRank(id);
    if (result.status) {
      setDataBenefitRank(result.data)
      // form.setFieldValue('title', result.data.title)
      // form.setFieldValue('price', result.data.price)
      // form.setFieldValue('code', result.data.code)
      // form.setFieldValue('img', result.data.icon)
      // setListBenefits(result.data.benefits.map(item => item.id))
      // setListBenefitPolicies(result.data.benefitPolicies.map(item => item.id))
      // if (result.data.carePolicies) {
      //   setListRankPolicies(result.data.carePolicies.map((item: any) => item.id))
      // }
    } else {
      pushToast(result.message, "error", 2000)
    }
  }


  const activeRank = async (id: number) => {
    const result = await RankApi.activeRank(id);
    if (result.status) {
      getListRank()
      // setDataBenefitRank(result.data)
      // form.setFieldValue('title', result.data.title)
      // form.setFieldValue('price', result.data.price)
      // form.setFieldValue('code', result.data.code)
      // form.setFieldValue('img', result.data.icon)
      // setListBenefits(result.data.benefits.map(item => item.id))
      // setListBenefitPolicies(result.data.benefitPolicies.map(item => item.id))
      // if (result.data.carePolicies) {
      //   setListRankPolicies(result.data.carePolicies.map((item: any) => item.id))
      // }
    } else {

      if (result.errorCode === 2) {
        setShowWarning(true)
        setMessageWarning(result.message ?? '')
      } else {
        pushToast(result.message, "error", 2000)

      }

    }
  }

  const handleDelete = async () => {
    if (id) {
      const result = await RankApi.deleteRank(id);
      if (result?.status) {
        getListRank()
        setOpenDeleteListRank(false)
        pushToast(result?.message, "success", 2000)

      } else {
        pushToast(result?.message, "error", 2000)

      }
    }
  }
  useEffect(() => {
    getListRank()
  }, [])

  return (
    <div className='class-list-page'>
      <Layout>

        <ModalScoringRules
          isOpen={isModalScoringRules}
          closeModal={() => setIsModalScoringRules(false)}

        />

        <ModalDeleteManager
          isOpen={openDeleteListRank}
          onConfirm={handleDelete}
          closeModal={() => setOpenDeleteListRank(!openDeleteListRank)}
          title="Bạn có chắc chắn xóa hạng thành viên này"
          titleDelete="Xóa hạng thành viên"
          content="Hạng thành viên và dữ liệu liên quan sẽ bị xóa vĩnh viễn
    không thể khôi phục"/>

        <ModalWarning
          isOpen={isShowWarning}
          onConfirm={() => setShowWarning(false)}
          closeModal={() => setShowWarning(false)}
          title="Không thể thực hiện thao tác"
          titleWarning="Đã hiểu"
          content={messageWarning}

        />
        <Breadcrumb
          items={[
            {
              title: 'THACO AUTO CRM',
            },
            {
              title: <a href="/">Chương trình KH thành viên</a>,
            },
            {
              title: 'Danh sách hạng',
            },
          ]}
        />
        <div className='title-page'>Danh sách hạng</div>

        <div
          className={`count-add-rank ${checkDisabledPermission(add)}`}
        >
          <div className="count-rank">Có {total} hạng đã được tạo ra</div>
          <div className="custom-page-css flex items-center justify-end gap-2">
            {/* <Button>
              Thiết lập thời gian tính hạng
            </Button>
            <Button onClick={() => setIsModalScoringRules(true)}>
              Quy tắc tính điểm
            </Button> */}
            <Button
              type='primary'
              icon={<PlusCircleOutlined />}
              onClick={() => navigate('/member-card/class-list/add')}>
              Thêm mới hạng
            </Button>
            {/* <Link to="/member-card/class-list/add" className="t-btn-link-icon">
              <div className="icon-svg"><PlusCircleOutlined /></div>
              <div className="text"></div>
            </Link> */}
          </div>
        </div>

        <div className="list-rank">
          {dataRank.map((item, index) => (
            <div key={index} className="one-rank">

              <div className="img-box">
                <img
                  src="/bg-rank.svg"
                  alt="bg rank"
                />
              </div>
              <div className="top">
                <div className="icon-name-rank">
                  <Switch size='small'
                    value={item.status ? true : false}
                    onChange={() => activeRank(item.id)}
                  />

                  <div className="icon-svg">

                    <img
                      src={URL_RANK + item.icon}
                      alt="sv"
                      onError={(e) => {
                        e.currentTarget.src = none_rank;
                      }}
                    />
                  </div>

                  <Tooltip title={item?.title} >
                    <div className="name  text-truncate">{item.title}</div>
                  </Tooltip>
                </div>
                <div className="list-icon-ctrl">
                  {/* <div
                    className="one-ctrl"
                    onClick={() => navigate('/member-card/class-list/add')}>
                    <CopyOutlined />
                  </div> */}
                  <div
                    className={`one-ctrl ${checkDisabledPermission(edit)}`}
                    onClick={() =>
                      navigate(
                        `/member-card/class-list/edit`,
                        {
                          state: {
                            id: item.id,
                          }
                        }
                      )
                    }
                  >
                    <EditOutlined />
                  </div>
                  <div className={`one-ctrl ${checkDisabledPermission(edit)}`}
                    onClick={() => { getInfoRank(item.id); setShowRank(true) }} >
                    <EyeOutlined />
                  </div>
                  {/* <div className={`one-ctrl ${checkDisabledPermission(isDelete)}`}
                    onClick={() => { setOpenDeleteListRank(true); setId(item.id) }}
                  >
                    <DeleteOutlined className='text-F5222D' />
                  </div> */}
                  <div
                    className={`one-ctrl ${checkDisabledPermission(add)}`}
                    // onClick={() => { setOpenDeleteListRank(true); setId(item.id) }}
                    onClick={() => {
                      navigate(
                        `/member-card/class-list/add`,
                        {
                          state: {
                            id: item.id,
                          }
                        }
                      );

                    }}
                  >
                    <CopyOutlined />
                  </div>
                </div>
              </div>
              <div className="footer">{item.type === 1 ? `Cần chi tiêu ${item.totalAmount.toLocaleString('en-US')} VNĐ để đạt chính sách này` : `Cần tổng chi tiêu mua xe tối thiểu ${item.totalPurchaseAmount.toLocaleString('en-US')} VNĐ hoặc tổng chi tiêu dịch vụ tối thiểu ${item.totalServiceAmount.toLocaleString('en-US')} VNĐ để đạt hạng này`}  </div>
              <div className="custom-page-css w-full flex flex-wrap gap-2 pt-2">
                <div className='custom-page-css flex  items-center justify-center rounded border-91D5FF bg-E6F7FF py-1 px-2'>
                  <span className='text-xs text-096DD9'>#{item.sortOrder} </span>
                </div>
                <div className='custom-page-css flex items-center justify-center rounded border-FA541C bg-FFF2E8 py-1 px-2'>
                  <span className='text-xs text-FA541C'>{item.totalBenefits} quyền lợi hạng</span>
                </div>
                <div className='custom-page-css flex items-center justify-center rounded border-FFBB96 bg-FFF2E8 py-1 px-2'>
                  <span className='text-xs text-D4380D'>{item.totalCarePolicies} chính sách CSKH</span>
                </div>
                <div className='custom-page-css flex items-center justify-center rounded border-FFD591 bg-FFF7E6 py-1 px-2'>
                  <span className='text-xs text-D46B08'>{item.totalBenefitPolicies} quyền lợi chính sách CSKH</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {
          isShowRank
            ? <ShowRank
              dataBenefitRank={dataBenefitRank}
              className="show showrank"
              onClose={() => { setShowRank(false) }}
            />
            : null
        }

      </Layout>
    </div>
  );
}

export default ClassList;
